<div class="modal-header container-md" id="modal-header">
  <div class="col-4"></div>
  <div class="col-4">
    <img
      id="modal-memorabid-logo"
      src="/assets/img/memorabid-logo-white.svg"
      alt="MEMORABID"
    />
  </div>
  <div class="col-3"></div>
  <div class="col-1">
    <button
      id="closeButton"
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body mx-3">
  <div *ngIf="!isBuyNow">
    <div class="d-flex justify-content-center mt-3">
      <h4 class="text-uppercase">{{'IDS_BID_CONFIRMED' | translate}}</h4>
    </div>
    <div
      class="row mt-2"
    >
      <div class="container-md">
        <div class="d-flex justify-content-end text-white">
            <div
              class="bidImageBottomLeft losing me-auto"
              *ngIf="selectedAuction.currentMaxIDUserBidder != authService.userLogged.idUser"
            >
              <div class="bid-info-icon">
                <fa-icon [icon]="faExclamation" size="sm"></fa-icon>
              </div>
              <label class="bidImageText text-uppercase">{{"IDS_OFFER_OUTBID" | translate}}</label>
            </div>
            <div
              class="bidImageBottomLeft winning me-auto"
              *ngIf="selectedAuction.reservePriceReached && selectedAuction.currentMaxIDUserBidder == authService.userLogged.idUser"
            >
              <div class="bid-info-icon">
                <fa-icon [icon]="faCheck" size="sm"></fa-icon>
              </div>
              <label class="bidImageText text-uppercase">{{"IDS_OFFER_HIGHER" | translate}}</label>
            </div>
            <div
              class="bidImageBottomLeft reserve-price-not-reached me-auto"
              *ngIf="!selectedAuction.reservePriceReached && selectedAuction.currentMaxIDUserBidder == authService.userLogged.idUser"
            >
              <div class="bid-info-icon">
                <fa-icon [icon]="faExclamation" size="sm"></fa-icon>
              </div>
              <label class="bidImageText text-uppercase">{{"IDS_OFFER_HIGHER_RESERVE_NOT_REACHED" | translate}}</label>
            </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 align-items-end article__word--medium-screen mx-0" *ngIf="selectedAuction.buyItNow == false">
      <div class="info col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
          <label class="text"
              *ngIf="selectedAuction.currentMaxOfferedPrice != null && selectedAuction.currentMaxOfferedPrice > 0">
              {{'IDS_LAST_BID' | translate}}
          </label>
          <label class="text"
              *ngIf="selectedAuction.currentMaxOfferedPrice == null || selectedAuction.currentMaxOfferedPrice == 0">
              {{'IDS_BASE_PRICE' | translate}}
          </label>
      </div>
      <div class="col">
          <label class="price"
              *ngIf="selectedAuction.currentMaxOfferedPrice != null && selectedAuction.currentMaxOfferedPrice > 0"
              >
              {{ selectedAuction.currentMaxOfferedPrice }} €
          </label>
          <label class="price"
              *ngIf="selectedAuction.currentMaxOfferedPrice == null || selectedAuction.currentMaxOfferedPrice == 0"
              >
              {{ selectedAuction.basePrice }} €
          </label>
      </div>
    </div>
  </div>
  <div *ngIf="isBuyNow">
    <div class="text-center mt-3">
      <h4 class="text-uppercase">{{'IDS_BUY_NOW_CONFIRMED' | translate}}</h4>

      <p>{{'IDS_BUY_NOW_CONFIRMED_MESSAGE' | translate}}</p>
    </div>
  </div>
  <div class="d-flex justify-content-center my-3">
    <button
      class="admin-new text-uppercase fw-bold px-3"
      type="button"
      (click)="activeModal.close()"
    >
      {{'IDS_OK' | translate}}
    </button>
  </div>
</div>
